import React from "react";
import emailjs from "emailjs-com";
import { FaPhoneAlt } from "react-icons/fa";
import $ from "jquery";

export default function Contact() {
  function sendEmail(e) {
    e.preventDefault();
    if (document.getElementById("contactName").value.trim() === "") {
      document
        .getElementById("contactName")
        .classList.add("border", "border-danger");
      return;
    } else if (document.getElementById("contactMessage").value.trim() === "") {
      document
        .getElementById("contactMessage")
        .classList.add("border", "border-danger");
      return;
    }
    document
      .getElementById("contactName")
      .classList.remove("border", "border-danger");
    document
      .getElementById("contactMessage")
      .classList.remove("border", "border-danger");
    document.getElementById("mailSpinner").classList.remove("d-none");
    document.getElementById("mailSuccess").classList.add("d-none");
    document.getElementById("mailFailed").classList.add("d-none");
    emailjs
      .sendForm(
        "service_amkzg7a",
        "contact_form",
        e.target,
        "user_NwoAP3xlDJ5Bjg3B3Sdxo66"
      )
      .then(
        (result) => {
          document.getElementById("mailSpinner").classList.add("d-none");
          document.getElementById("mailSuccess").classList.remove("d-none");
        },
        (error) => {
          document.getElementById("mailSpinner").classList.add("d-none");
          document.getElementById("mailFailed").classList.remove("d-none");
        }
      );
  }
  return (
    <div>
      <span data-toggle="modal" data-target="#contactModal">
        <button
          className="btn btn-sm btn-outline-light"
          disabled
          data-toggle="tooltip"
          data-placement="bottom"
          title="راسلنا"
          onClick={() => {
            document.getElementById("contactName").value = "";
            document.getElementById("contactMessage").value = "";
            document.getElementById("mailSpinner").classList.add("d-none");
            document.getElementById("mailSuccess").classList.add("d-none");
            document.getElementById("mailFailed").classList.add("d-none");
            document
              .getElementById("contactName")
              .classList.remove("border", "border-danger");
            document
              .getElementById("contactMessage")
              .classList.remove("border", "border-danger");
            $("button").tooltip("hide");
          }}
        >
          <FaPhoneAlt size="1.2em" />
        </button>
      </span>
      <div
        className="modal fade"
        id="contactModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title text-dark" id="exampleModalLabel">
                راسلنا
              </h5>
              <button
                type="button"
                className="close ml-0"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="alert alert-success m-2 mb-0 p-2 d-none text-center"
              role="alert"
              id="mailSuccess"
            >
              <p className="p-0 m-0">تم الارسال بنجاح</p>
            </div>
            <div
              className="alert alert-danger m-2 mb-0 p-2 d-none text-center"
              role="alert"
              id="mailFailed"
            >
              <p className="p-0 m-0">حدث خطأ. حاول مرة اخرى</p>
            </div>
            <div className="modal-body">
              <form onSubmit={sendEmail}>
                <div className="form-row">
                  <div className="form-group col-md-12 text-right">
                    <label
                      htmlFor="inputEmail4"
                      className="text-dark"
                      name="subject"
                    >
                      الاسم
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="contactName"
                      name="user_name"
                      onChange={() => {
                        document
                          .getElementById("contactName")
                          .classList.remove("border", "border-danger");
                      }}
                    ></input>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-12 text-right mb-0">
                    <label htmlFor="inputEmail4" className="text-dark">
                      الرسالة
                    </label>
                    <textarea
                      className="form-control"
                      name="message"
                      id="contactMessage"
                      onChange={() => {
                        document
                          .getElementById("contactMessage")
                          .classList.remove("border", "border-danger");
                      }}
                      rows="3"
                    ></textarea>
                    <small className="form-text text-muted" id="emailHelp">
                      في حال الرغبة في الرد على استفسارك او اقتراحك ، يرجى ترك
                      بريدك او رقم هاتفك المحمول في الرسالة.
                    </small>
                    <div className="col text-center">
                      <button
                        type="submit"
                        className="btn btn-primary p-1 mt-3 w-25 text-center"
                        // data-dismiss="modal"
                        onSubmit={sendEmail}
                      >
                        ارسال
                        <div
                          className="spinner-border spinner-border-sm text-light p-1 mr-2 d-none"
                          role="status"
                          id="mailSpinner"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                اغلاق
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
